/* ********************** *
* Initialise the tab view *
* *********************** */
function initTabView () {

    // Display the content for the specified tab. The argument (tabId) must include the hash (#) symbol
    var switchToTab = function (tabId) {
        var activeTab = $('.tab-view .tabs > .active');
        activeTab.removeClass('active');

        var activeTabContent = $(activeTab.children().attr('href'));
        activeTabContent.addClass('hidden');

        var newTab = $('.tab-view .tabs a[href=\"' + tabId + '\"]');
        newTab.parent().addClass('active');

        $(tabId).removeClass('hidden');
    };

    // Switch to the selected tab
    $('.tab-view .tabs a').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        switchToTab(target);

        // Prefix the hash with a string to prevent the browser jumping to the element with the selected ID
        window.location.hash = 'tab-' + target.replace('#', '');
    });

    $('.tab-view select.tabs').change(function (e) {
        e.preventDefault();

        switchToTab($(this).val());

        if ($(this).val().toString().toLowerCase() == "#streetview") {
            initPropertyStreetView();
        }

        window.location.hash = 'tab-' + $(this).val().replace('#', '');

        if ($(this).children('option').data('behaviour') != 'undefined') {
            setTimeout(function () {
                initPropertyMap();
            }, 100);
        }
    });

    // Automatically switch to the tab specified in the hash part of the URL
    if (window.location.hash && window.location.hash.match('^#tab-')) {
        var tabId = window.location.hash.substr(5);
        $('a[href=\"#' + tabId + '\"]').click();

        // Jump to tab
        $('html, body').scrollTop($('#' + tabId).offset().top);
    }

}